import React from 'react';
import clsx from 'clsx';
import CohortClauseTools from '../containers/CohortClauseTools';

const QueryClauseTableRowName = ({
  canEdit,
  category,
  clause,
  code,
  isEditing,
  queryUUID,
}) => (
  <>
    <span className={clsx('aridhia-query-clause-name', !isEditing && 'aridhia-query-clause-name--no-edit')}>
      {clause.name}
    </span>
    {canEdit && (
      <CohortClauseTools
        iconSize="large"
        category={category}
        code={code}
        queryUUID={queryUUID}
        clauseUUID={clause.uuid}
        dictionaryCode={clause.dictionary?.code}
      />
    )}
  </>

);

export default QueryClauseTableRowName;
